<template>
    <v-card min-height="350" class="donutComponent" @mouseover="hover = true" @mouseout="hover = false">
        <v-card-title style="height:20%; justify-content:space-between;">
            {{$t(data.label)}}
            <v-btn v-show="innerFilters.length > 0" small depressed dark :color="innerFilters.length > 0 ? 'primary' : 'darkgrey'" @click="addFilter">{{$t('filter')}}</v-btn>
        </v-card-title>
        <v-card-text style="padding: 0;" v-if="graphData.datasets[0].data && graphData.datasets[0].data.length">
            <DonutComponent :dataSet="graphData" :legend="false" @selectItem="selectItem" style="height:200px;"/>
        </v-card-text>
        <v-card-text v-if="graphData.datasets[0].data && graphData.datasets[0].data.length">
            <div class="legend mr-6">
                <div v-for="(legend, index) in this.labels" @click="selectItem(index)" style="cursor:pointer" :key="'legend_'+index">
                    <span :style="'width: 20px; height:10px; display:inline-block; background-color:'+backgroundRefs[index]"></span> {{legend}}
                </div>
            </div>
        </v-card-text>
        <v-card-text v-else>
            <v-alert border="left" color="info" text>
                {{ $t('emptyItemArrayInfoMessage') }}
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
import DonutComponent from '@/components/graphs/DonutComponent'
export default {
    name:"donutContactStatsComponent",
    components:{DonutComponent},
    props:['data', 'filters'],
    data() {
        return {
            hover: false,
            default_colors: [
                "#2563EB", "#3B82F6", "#06B6D4", "#14B8A6", "#10B981",
                "#84CC16", "#FACC15", "#F59E0B", "#FB923C", "#F97316",
                "#EF4444", "#F43F5E", "#EC4899", "#A855F7", "#6366F1",
                "#C084FC", "#64748B", "#94A3B8", "#A5F3FC", "#86EFAC"
            ],
            backgroundRefs: [],
            innerFilters: [],
            graphData: {},
        }
    }, //"#F0FFFF","#F0F8FF",
    mounted() {
        this.defineColors();
    },
    created() {
        this.defineColors();
    },
    methods: {
        defineColors() {
            let backgroundColors = [];
            this.labels.forEach((label, index) => {
                let indexColor = Math.floor(Math.random()*this.default_colors.length)
                backgroundColors.push(this.default_colors[indexColor]) 
                this.default_colors.splice(indexColor, 1);
                if(this.filters && this.filters.includes(label) && !this.innerFilters.includes(index)){
                    this.innerFilters.push(index)
                } 
            });
            if(this.data.backgroundColor){
                this.backgroundRefs = this.data.backgroundColor
            } else {
                this.backgroundRefs = backgroundColors
            }
            this.updateColors();
        },
        selectItem(index){
            let tmpIndex = Object.keys(this.data.datas)[index];

            if(!this.data.datas[tmpIndex].notFilterable) {
                if(this.innerFilters && this.innerFilters.includes(index)){
                    let indexToRemove = this.innerFilters.findIndex((e) => e == index)
                    this.innerFilters.splice(indexToRemove, 1);
                } else {
                    this.innerFilters.push(index);
                }
                this.updateColors();
            }
        },
        updateColors(){
            this.backgroundRefs.forEach((color, index) => {
                if(this.innerFilters.length > 0){
                    if(this.innerFilters.includes(index)){
                        this.backgroundRefs[index] = color.substring(0,7)
                    } else {
                        this.backgroundRefs[index] = color.substring(0,7)+"55"
                    }
                } else {
                    this.backgroundRefs[index] = color.substring(0,7)
                }
            });
            this.graphDataFct();
        },
        graphDataFct(){
            let graphData = {}
            graphData.datasets = [];

            let dataset = {};
            dataset.label = "";
            dataset.data = Object.values(this.data.datas).map(function (obj) { return obj.value });
            dataset.backgroundColor =  this.backgroundRefs;
            graphData.datasets.push(dataset);
            graphData.labels = this.labels;

            this.graphData = graphData;
        },
        addFilter() {
            this.$emit('addFilter', this.data.label, this.innerFilters);
            this.innerFilters = [];
        }
    }, 
    computed: {
        labels() {
            return Object.values(this.data.datas).map(function (obj) { return this.data.to_trad || obj.to_trad ? this.$t(obj.label) : obj.label; }, this);
        }
    },
}
</script>
<style lang="scss">
    .donutComponent {
        h2 {
            margin-bottom:0;
            align-items: center;
        }
        .legend {
            max-height: 100%;
        }
    }
</style>